import { i18n } from '@apps/main/modules/localization/localizationSetup';

const { t } = i18n.global;

export const SELECT_TIME_FOR_ME_ID = 'selectTimeForMeId' as const;

export const SELECT_TIME_FOR_ME_OPTION = {
  id: SELECT_TIME_FOR_ME_ID,
  label: t('planner.suggest_available_time'),
};
export const enum ActivityDetailsTemplateId {
  TicketRates = 'ticket-rates',
}
